import React from 'react'
import { useSelector } from 'react-redux'
import { selectActiveSort, selectCurrentMode, selectIsComputingDone } from '../../store/itinerary/itinerary.selectors'
import { MULTIPATH_MODE_TC } from '../../store/itinerary/itinerary.constants'
import s from './ItineraryResultFaqLink.less'
import questionMarkIcon from './question_mark.svg'
import T from '../i18n/T'
import { selectArrivalStep, selectDepartureStep } from './steps/steps.selectors'

const ItineraryResultFaqLink = () => {
  const currentMode = useSelector(selectCurrentMode)
  const isComputingDone = useSelector(selectIsComputingDone)
  const departureStep = useSelector(selectDepartureStep)
  const arrivalStep = useSelector(selectArrivalStep)
  const isSortModeActive = Boolean(useSelector(selectActiveSort))

  if (
    currentMode !== MULTIPATH_MODE_TC ||
    !isComputingDone ||
    departureStep?.label === arrivalStep?.label ||
    isSortModeActive
  )
    return <></>

  return (
    <div className={s.linkContainer}>
      <img src={questionMarkIcon} className={s.icon} />
      <a
        className={s.link}
        href="https://faq.mappy.com/knowledgebase/articles/1811887-le-comparateur-d-itin%C3%A9raires-mappy#at_medium=self_promotion&at_campaign=faq_web"
      >
        <T id="itinerary.result.faq.link" />
      </a>
    </div>
  )
}

export default ItineraryResultFaqLink
